export const ActionTypes = {
	CART_ADD:"cart_add",
	CART_UPDATE:"cart_update",
	CART_REMOVE:"cart_delete",
	CART_CLEAR:"cart_clear",
}


